import { computed, onMounted, reactive, ref, createVNode } from 'vue'
import { message, Modal } from 'ant-design-vue'
import moment from 'moment'
import {
  visitsDetail,
  visitsDetailNew,
  cancelVisitPlan,
  getPrescriList,
  updataVisitPrescri,
  updataPlanFlow,
  cancelPlanFlow,
  createPlanFlow
} from '@/api/workPlace/visits.js'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { isPlanOrVisitMethods } from '@/hooks/globalApi'
export default function useVisitDetail(props, emit) {
  // const emit = defineEmits(['jumpTo', 'noDetail'])
  const addPrescriVisible = ref(false)
  const prescriptionId = ref('') // 增加处方id
  const editStageVisible = ref(false) // 编辑随访阶段
  const addStageVisible = ref(false) // 新增随访阶段
  const currentStageInfo = ref({})
  // 详情信息
  const info = reactive({
    loading: false,
    // 基本信息
    base: {},
    // 随访计划流程
    followUpPlanFlows: []
  })
  // let activeKey = ref('1')

  // 获取详情
  function getVisitsDetail() {
    // 判断是用药计划还是随访
    isPlanOrVisitMethods({ id: props.id }, res => {
      if (res.dateFlg) {
        getDetail_plan()
      } else {
        getDetail_visits()
      }
    })
  }
  function getDetail_visits() {
    info.loading = true
    const params = {
      planType: props.planType,
      followupPlanId: props.id
    }
    visitsDetail(params)
      .then(result => {
        info.base = result
        // 随访计划流程
        info.followUpPlanFlows = result.followUpPlanStageVoList || []
      })
      .catch(() => {
        emit('noDetail', props.id, '')
      })
      .finally(() => (info.loading = false))
  }

  function getDetail_plan() {
    info.loading = true
    const params = {
      planType: props.planType,
      medicationScheduleId: props.id
    }
    visitsDetailNew(params)
      .then(result => {
        info.base = result
        // 随访计划流程
        info.followUpPlanFlows = result.followUpPlanStageVoList || []
      })
      .catch(() => {
        emit('noDetail', props.id, '')
      })
      .finally(() => (info.loading = false))
  }

  const visitState = computed(() => state => {
    // 0未开始 1进行中 2已结束 3已取消
    var hps = ['未开始', '进行中', '已结束', '已取消']
    return hps[state]
  })
  // 取消随访
  function closeVisit() {
    cancelVisitPlan(props.id).finally(() => getVisitsDetail())
  }
  /**
   * @description: 打开详情页
   * @param {String} is 组件名称
   * @param {Number} id id
   * @param {String} serialNumber  编号
   */
  function jumpTo(is, id, serialNumber) {
    emit('jumpTo', is, id, serialNumber)
  }

  // 关闭增加处方弹窗
  function cancelAddPrescri() {
    prescriptionId.value = ''
  }

  //编辑随访
  function handleEdit(data) {
    editStageVisible.value = true
    currentStageInfo.value = data
  }
  //取消随访
  function handleCancel(id) {
    Modal.confirm({
      centered: true,
      title: '取消推送',
      icon: createVNode(ExclamationCircleOutlined),
      content: '确定取消该疗效跟踪阶段的工单推送吗？',
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        cancelPlanFlow({ flowId: id }).then(() => {
          getVisitsDetail()
        })
      }
    })
  }
  // 编辑随访阶段
  function editStage(arg) {
    const { flowId, followDate, flowResultStatus, flowNum } = arg
    const params = {
      flowId,
      flowTime: moment(followDate).format('YYYY-MM-DD') + ' ' + '10:00:00',
      flowResultStatus,
      i: flowNum
    }
    updataPlanFlow(params).then(() => {
      getVisitsDetail()
    })
  }
  function addStage(arg) {
    const { followupPlanId, followDate, flowNum } = arg
    const params = {
      followupPlanId,
      flowTime: moment(followDate).format('YYYY-MM-DD') + ' ' + '10:00:00',
      i: flowNum
    }
    createPlanFlow(params).then(() => {
      getVisitsDetail()
    })
  }
  onMounted(() => {
    getVisitsDetail()
  })
  const prescriList = ref([])
  const searchPrescriList = value => {
    const params = {
      followupPlanId: info.base.followupPlanId,
      serialNumber: value
    }
    getPrescriList(params)
      .then(res => {
        prescriList.value = res
      })
      .catch(() => {
        prescriList.value = []
      })
  }
  // 增加处方
  function handleAddPrescri() {
    if (!prescriptionId.value) {
      return message.warning('请输入正确的处方ID。')
    }
    const params = {
      srcId: info.base.followupPlanId,
      tagId: prescriptionId.value
    }
    updataVisitPrescri(params)
      .then(() => {
        addPrescriVisible.value = false
        getVisitsDetail()
      })
      .catch(err => message.warning(err))
  }
  function handleBtnStatus(status) {
    if (props.mode || props.planType) {
      return false
    } else {
      return [0, 1].includes(status)
    }
  }
  const nextFlowNum = ref('')
  function handleAddStage() {
    const { followUpPlanFlows = [] } = info
    const len = followUpPlanFlows.length
    const reg = /第(.*)次疗效跟踪/
    if (len) {
      try {
        const list = followUpPlanFlows
          .filter(item => item.stageName !== '复诊提醒')
          .sort(({ stageName: a }, { stageName: b }) => {
            const res1 = reg.exec(a)
            const res2 = reg.exec(b)
            return res2[1] - res1[1]
          })
        nextFlowNum.value = list[0].stageName
      } catch {
        nextFlowNum.value = '第1次疗效跟踪'
      }
    } else {
      nextFlowNum.value = '第1次疗效跟踪'
    }
    addStageVisible.value = true
  }
  // NOT_PUSHED(0,"未推送"),
  // PUSHED(1,"已推送"),
  // CANCEL_PUSH(2,"取消推送"),
  // DO_NOT_PUSH(3,"不推送");
  function showEditBtn(record) {
    // TODO 历史数据里面的复诊提醒是否兼容处理了
    const { pushStatusCode, flowEditByType } = record
    return pushStatusCode !== 2 && flowEditByType === 1
  }
  function showCancelBtn(record) {
    const { pushStatusCode } = record
    return pushStatusCode === 0
  }
  // 编辑人展示
  function calcEditLabel(record) {
    const { flowEditByType } = record
    return {
      background: flowEditByType === 1 ? '#F9F0FF' : '#FFEED9',
      color: flowEditByType === 1 ? '#722ED1' : '#FFA940'
    }
  }
  return {
    addPrescriVisible,
    prescriptionId,
    info,
    visitState,
    closeVisit,
    jumpTo,
    handleAddPrescri,
    cancelAddPrescri,
    handleEdit,
    handleCancel,
    editStageVisible,
    currentStageInfo,
    editStage,
    searchPrescriList,
    prescriList,
    addStageVisible,
    addStage,
    handleBtnStatus,
    handleAddStage,
    nextFlowNum,
    showCancelBtn,
    showEditBtn,
    calcEditLabel
  }
}
